import { apiFetch } from "../../core/utils/api";

export async function reorderEntity({ type, id, order }) {
  if (type === "component") {
    const res = await apiFetch(`/api/components/${id}/reorder/`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ order }),
    });
    if (!res.ok) throw new Error("Failed to reorder component");
    return res.json();
  }
  const res = await apiFetch(`/api/items/${id}/reorder/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ order }),
  });
  if (!res.ok) throw new Error("Failed to reorder item");
  return res.json();
}

export async function moveComponent({ id, toParentComponentId = null, toParentWebsitePageId = null, order = null }) {
  const res = await apiFetch(`/api/components/${id}/move/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      to_parent_component_id: toParentComponentId,
      to_parent_website_page_id: toParentWebsitePageId,
      order,
    }),
  });
  if (!res.ok) throw new Error("Failed to move component");
  return res.json();
}

export async function moveItem({ type, id, toComponentId, toParentHeroId, order = null }) {
  const res = await apiFetch(`/api/items/${type}/${id}/move/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ to_component_id: toComponentId, to_parent_hero_id: toParentHeroId, order }),
  });
  if (!res.ok) throw new Error("Failed to move item");
  return res.json();
}

export async function bulkReorderChildren({ parentId, children }) {
  const res = await apiFetch(`/api/components/${parentId}/reorder-children/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ children }),
  });
  if (!res.ok) throw new Error("Failed to bulk reorder children");
  return res.json();
}

export async function reorderNavbarSections({ navbarId, sections }) {
  const res = await apiFetch(`/api/websites/${navbarId}/navbar/sections/reorder/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ sections }),
  });
  if (!res.ok) throw new Error("Failed to reorder navbar sections");
  return res.json();
}

export async function reorderSidebarSections({ sidebarId, side, sections }) {
  const base = side === "left" ? "leftsidebar" : "rightsidebar";
  const res = await apiFetch(`/api/websites/${sidebarId}/${base}/sections/reorder/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ sections }),
  });
  if (!res.ok) throw new Error("Failed to reorder sidebar sections");
  return res.json();
}

export async function reorderButtonCollection({ collectionId, buttonIds }) {
  const res = await apiFetch(`/api/items/button_collection/${collectionId}/reorder/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ button_ids: buttonIds }),
  });
  if (!res.ok) throw new Error("Failed to reorder button collection");
  return res.json();
}


